module.exports = __webpack_public_path__ + "img/highlight-icon3-hover.46d8e5b3.png";